import { ChevronDown, ChevronUp } from '@mollie/ui-assets/icons/utilitarian';
import clsx from 'clsx';
import React, { createContext, useContext } from 'react';
import { flattenChildren, useControlledValue } from '../../utils';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { TableCell } from './TableCell';
import { TableRow } from './TableRow';
import { TableSection } from './TableSection';
const TableGroupContext = createContext({
    parentCount: 0,
    parentOpen: false,
});
const useTableGroupContext = () => useContext(TableGroupContext);
export function TableGroup(props) {
    const { children, className, open, defaultOpen = false, onChange } = props;
    const [groupOpen, setGroupOpen] = useControlledValue({
        value: open,
        onChange,
        defaultValue: defaultOpen,
    });
    const { parentCount, parentOpen } = useTableGroupContext();
    const hasParent = parentCount > 0;
    const onToggleGroup = () => setGroupOpen((groupOpen) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(!groupOpen);
        return !groupOpen;
    });
    const isOpen = hasParent ? parentOpen && groupOpen : groupOpen;
    const groupChildren = (React.createElement(React.Fragment, null, flattenChildren(children).map((child, index) => {
        if (React.isValidElement(child) && child.type === TableRow) {
            const rowElement = child;
            return React.cloneElement(rowElement, {
                children: (React.createElement(React.Fragment, null,
                    React.createElement(TableCell, { className: "mollie-ui-table-group-toggle" }, index === 0 && flattenChildren(children).length > 1 && (React.createElement(Button, { unstyled: true, onClick: (e) => {
                            e.stopPropagation();
                            onToggleGroup();
                        }, "data-mollie-ui-table-group-toggle": groupOpen, "data-table-row-tabbable": true },
                        React.createElement(Icon, { src: groupOpen ? ChevronUp : ChevronDown })))),
                    rowElement.props.children)),
                hidden: isOpen
                    ? false
                    : hasParent && index === 0
                        ? !parentOpen
                        : index > 0,
                onClick: index === 0 && flattenChildren(children).length > 1
                    ? onToggleGroup
                    : rowElement.props.onClick,
                style: {
                    '--mollie-ui-table-group-parent-count': parentCount,
                },
            });
        }
        return child;
    })));
    if (!hasParent) {
        return (React.createElement(TableGroupContext.Provider, { value: { parentCount: parentCount + 1, parentOpen: isOpen } },
            React.createElement(TableSection, { elementType: "tbody", className: clsx('mollie-ui-table-group', {
                    'mollie-ui-table-group--open': isOpen,
                }, className) }, groupChildren)));
    }
    return (React.createElement(TableGroupContext.Provider, { value: { parentCount: parentCount + 1, parentOpen: isOpen } }, groupChildren));
}
TableGroup.displayName = 'Table.Group';
//# sourceMappingURL=TableGroup.js.map